import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onRequestConsultation: () => void;
}

const CTASection = ({ onRequestConsultation }: CTASectionProps) => {
  return (
    <section className="py-20 bg-gradient-to-r from-primary via-brand-navy to-secondary relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-brand-gold rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-headline font-bold text-white mb-6">
            Ready to Elevate Your Corporate Identity?
          </h2>
          <p className="text-xl font-body text-gray-200 mb-8 leading-relaxed">
            Join Tanzania's leading institutions in partnering with Pink Diamond for premium uniform solutions that embody professional excellence!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <button
              onClick={onRequestConsultation}
              className="px-8 py-4 bg-brand-gold text-brand-gold-foreground font-cta font-semibold rounded-lg hover:bg-opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center space-x-2"
            >
              <span>Request Free Consultation</span>
              <Icon name="ArrowRightIcon" size={20} variant="outline" />
            </button>
            <button
              onClick={onRequestConsultation}
              className="px-8 py-4 bg-white bg-opacity-10 backdrop-blur-sm text-white font-cta font-semibold rounded-lg hover:bg-opacity-20 transition-all duration-300 border border-white border-opacity-30 flex items-center space-x-2"
            >
              <Icon name="PhoneIcon" size={20} variant="outline" />
              <span>Call Us Today</span>
            </button>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-white">
            <div className="flex flex-col items-center">
              <Icon name="ClockIcon" size={40} variant="outline" className="mb-3" />
              <h3 className="text-lg font-headline font-semibold mb-2">Fast Turnaround</h3>
              <p className="text-sm font-body text-gray-200">
                From consultation to delivery in weeks, not months
              </p>
            </div>
            <div className="flex flex-col items-center">
              <Icon name="CurrencyDollarIcon" size={40} variant="outline" className="mb-3" />
              <h3 className="text-lg font-headline font-semibold mb-2">Flexible Pricing</h3>
              <p className="text-sm font-body text-gray-200">
                Scalable solutions for organizations of all sizes
              </p>
            </div>
            <div className="flex flex-col items-center">
              <Icon name="UserGroupIcon" size={40} variant="outline" className="mb-3" />
              <h3 className="text-lg font-headline font-semibold mb-2">Dedicated Support</h3>
              <p className="text-sm font-body text-gray-200">
                Personal account manager for every partnership
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;